import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=cb1273b6&scoped=true&"
import script from "./nav.vue?vue&type=script&lang=js&"
export * from "./nav.vue?vue&type=script&lang=js&"
import style0 from "./nav.vue?vue&type=style&index=0&id=cb1273b6&lang=scss&scoped=true&"
import style1 from "./nav.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1273b6",
  null
  
)

export default component.exports